import FormBase from "../FormBase";
import FormFieldBase from "../FormFieldBase";
import ValidationBase, { ValidationType } from "../ValidationBase";
import Professional from '../../models/Professional'
import ProfessionalPrivilegeService from "../../services/ProfessionalPrivilegeService";
import ProfessionalPrivilege from "../../models/ProfssionalPrivilege";
import Privilege from "../../models/Privilege";
import FormFieldBaseTyped from "../FormFieldBaseTyped";
import OptionItemTyped from "../../models/OptionItemTyped";

export class ReRegistrationProfessionalPrivilegeFormItem {
    Id: number;
    Privilege: string | undefined;
    PrivilegeValue: OptionItemTyped<Privilege> | undefined;
    Title: string | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;

    constructor() {
        this.Id = 0;
    }

    static NewInstance(): ReRegistrationProfessionalPrivilegeFormItem {
        return new ReRegistrationProfessionalPrivilegeFormItem();
    }

}

export default class ReRegistrationProfessionalPrivilegeForm implements FormBase {

    Privilege: FormFieldBaseTyped<OptionItemTyped<Privilege>>;
    Title: FormFieldBase;
    FormItemList: ReRegistrationProfessionalPrivilegeFormItem[];
    FormRemoveList: ReRegistrationProfessionalPrivilegeFormItem[];
    FormItemToEdit: ReRegistrationProfessionalPrivilegeFormItem;

    constructor() {

        this.Privilege = new FormFieldBaseTyped<OptionItemTyped<Privilege>>(undefined, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
        this.Title = new FormFieldBase(undefined, []);;
        this.FormItemList = new Array<ReRegistrationProfessionalPrivilegeFormItem>();
        this.FormRemoveList = new Array<ReRegistrationProfessionalPrivilegeFormItem>();
        this.FormItemToEdit = ReRegistrationProfessionalPrivilegeFormItem.NewInstance();
    }

    AddOrUpdateReRegistrationProfessionalPrivilegeFormItem() {
        if (this.ValidateForm()) {

            //Insert
            if (this.FormItemToEdit === null || this.FormItemToEdit.Id === 0) {

                let item = ReRegistrationProfessionalPrivilegeFormItem.NewInstance();
                item.Id = this.getNewId();
                item.Privilege = this.Privilege.Value?.Value?.Description;
                item.PrivilegeValue = this.Privilege.Value;
                item.Title = this.Privilege.Value?.Value?.Speciality;
                this.FormItemList.push(item);

                //Update    
            } else {
                for (let index = 0; index < this.FormItemList.length; index++) {
                    const element = this.FormItemList[index];
                    if (element.Id === this.FormItemToEdit.Id) {

                        let item = ReRegistrationProfessionalPrivilegeFormItem.NewInstance();
                        item.Id = this.getNewId();
                        item.Privilege = element.Privilege;
                        item.PrivilegeValue = element.PrivilegeValue;
                        item.Title = element.Title;

                        item.RemoveTasy = element.RemoveTasy;
                        item.TasyCode = element.TasyCode;

                        this.FormItemList[index] = item;
                    }
                }
            }
            this.ResetForm();
        }
    }

    CallInsertOrUpdateApi(Professional: Professional): Promise<boolean> {
        const dataJson = this.getJsonObjet();
        return ProfessionalPrivilegeService.postInsertOrUpdateProfssionalPrivilege(dataJson, Professional.Id);
    }

    async PreloadFormFromApi(requestId: string): Promise<any> {


        return await ProfessionalPrivilegeService.CreateAndGetProfssionalPrivilegeFromTasy(requestId).then((data: ProfessionalPrivilege[]) => {

            this.FormItemList = new Array<ReRegistrationProfessionalPrivilegeFormItem>();
            this.FormRemoveList = new Array<ReRegistrationProfessionalPrivilegeFormItem>();

            for (let index = 0; index < data.length; index++) 
            {
                const element = data[index];
                let privilegeValue: OptionItemTyped<Privilege> = new OptionItemTyped<Privilege>("", "", undefined);

                if (element.Privilege !== undefined && element.PrivilegeDescription !== undefined) {
                    let privilege = new Privilege();
                    privilege.Description = element.PrivilegeDescription;
                    privilege.Id = element.Privilege;
                    privilegeValue = new OptionItemTyped<Privilege>(element.Privilege, element.PrivilegeDescription, privilege);
                }

                let item = ReRegistrationProfessionalPrivilegeFormItem.NewInstance();
                item.Id = this.getNewId();
                item.Privilege = element.PrivilegeDescription;
                item.PrivilegeValue = privilegeValue;
                item.Title = element.Title;
                item.RemoveTasy = element.RemoveTasy;
                item.TasyCode = element.TasyCode;

                this.FormItemList.push(item);

            }

        });
    }

    EditReRegistrationProfessionalPrivilegeFormItem(id: number) {
        this.ResetForm();

        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];

            if (element.Id === id) {
                this.FormItemToEdit = element;
                this.Privilege.Value = this.FormItemToEdit.PrivilegeValue;
                this.Title.Value = this.FormItemToEdit.Title;
            }
        }
    }

    RemoveReRegistrationProfessionalPrivilegeFormItem(id: number) {
        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];
            if (element.Id === id) {
                if (element.TasyCode === undefined || element.TasyCode === 0) {
                    this.FormItemList.splice(index, 1);
                } else {
                    element.RemoveTasy = true;
                    this.FormRemoveList.push(element);
                    //this.FormItemList.splice(index, 1);
                }
            }
        }
    }


    static NewInstance(): ReRegistrationProfessionalPrivilegeForm {
        return new ReRegistrationProfessionalPrivilegeForm();
    }

    ValidateForm(): boolean {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        return formIsValid;
    }


    ValidateToGoNextStep(): string {
        // if (this.FormItemList.length === 0) {
        //     return "Por favor, insira ao menos uma equipe."
        // }
        return "";
    }

    ResetForm(): void {
        let propNames = Object.getOwnPropertyNames(this);
        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];

            if(typeof(this.GetFieldByName(element).Value) === 'boolean'){
                this.GetFieldByName(element).Value = false; 
            }else{
                this.GetFieldByName(element).Value = undefined; 
            }
            this.GetFieldByName(element).Error = "";
        }

        this.FormItemToEdit = ReRegistrationProfessionalPrivilegeFormItem.NewInstance();
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Privilege":
                return this.Privilege;
            case "Title":
                return this.Title
            default:
                return new FormFieldBase("", []);
        }
    }


    getNewId(): number {
        if (this.FormItemList.length > 0) {
            let maxId = Math.max.apply(Math, this.FormItemList.map(function (o) { return o.Id; }))
            return maxId + 1;
        } else {
            return 1;
        }
    }


    getJsonObjet(professionalId: number = 0) {

        let viewModelList: any[] = [];

        if (this.FormItemList !== null && this.FormItemList.length > 0) {
            this.FormItemList.forEach((element: ReRegistrationProfessionalPrivilegeFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "privilegeDescription": element.PrivilegeValue?.Value?.Speciality,
                    "title": element.Title,
                    "privilegeId": element.PrivilegeValue?.Id,
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }

        if (this.FormRemoveList !== null && this.FormRemoveList.length > 0) {
            this.FormRemoveList.forEach((element: ReRegistrationProfessionalPrivilegeFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "privilegeDescription": element.PrivilegeValue?.Value?.Speciality,
                    "title": element.Title,
                    "privilegeId": element.PrivilegeValue?.Id,
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }

        return viewModelList;
    }
}